import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { OutletCard } from "../components/OutletCard";
import { LOCATIONS, HOURS_NOTE } from "../data/site";

export const LocationsPreview = () => (
  <section data-testid="locations-preview-section" className="mx-auto max-w-6xl px-5 py-16 sm:py-24">
    <div className="flex flex-wrap items-end justify-between gap-6">
      <div className="max-w-xl">
        <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-bumbu">
          Dua Titik, Satu Rasa
        </p>
        <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-charcoal sm:text-4xl">
          Pilih tempat antremu.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-charcoal-muted">
          Mampir ke outlet open space di Melawai atau ke kios pertama kami di
          Fresh Market Emerald Bintaro.
        </p>
      </div>
      <Link
        to="/lokasi/"
        data-testid="locations-preview-cta"
        className="inline-flex items-center gap-2 font-heading text-sm font-bold text-bawang transition-colors hover:text-bawang-dark"
      >
        Detail lokasi &amp; jam buka
        <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Link>
    </div>

    <div className="mt-12 grid gap-8 md:grid-cols-2">
      {LOCATIONS.map((loc) => (
        <OutletCard key={loc.id} location={loc} />
      ))}
    </div>

    <p className="mt-8 text-center text-xs leading-relaxed text-charcoal-muted">
      {HOURS_NOTE}
    </p>
  </section>
);
